<template>
 <button class="pagination-button"
         @click="$emit('set-active-page', pbuttonValue)"
         :style="pbuttonStyles"
         :class="{'active': pbuttonActive,
         'no-hover': pbuttonDisabled || pbuttonValue === '...'}"
         :disabled="pbuttonDisabled">
   <span v-if="!pbuttonIcon">{{pbuttonValue}}</span>
   <span v-else>
     <i class="n-i center-xy" :class="[pbuttonIcon]"></i>
   </span>
 </button>
</template>

<script>
export default {
  name: 'PaginationButton',
  data() {
    return {
      hover: false,
    };
  },
  props: [
    'pbuttonValue',
    'pbuttonDisabled',
    'pbuttonStyles',
    'pbuttonActive',
    'pbuttonIcon',
  ],
};
</script>

<style lang="scss" scoped>
  .pagination-button {
    border-radius: 1px;
    color: #808b9c;
    height: 30px;
    margin: 0 1px;
    position: relative;
    width: 30px;
    &:hover:not(.no-hover),
    &.active {
      background-color: #009aff !important;
      color: #fff !important;
    }
  }
</style>
